export default __webpack_public_path__ + "media/zurb/img/icons/services/lightbulb-e73aabf18adb483b3c97b170d6e5e60b.svg";